import { Calendar, Link, type LucideIcon } from "lucide-react";
import { ensureHttps } from "@eip/shared/utils/url";

export type MeetingProvider = {
  name: string;
  icon: LucideIcon;
};

const PROVIDER_PATTERNS: { hostname: string | string[]; name: string }[] = [
  { hostname: "calendly.com", name: "Calendly" },
  { hostname: "cal.com", name: "Cal.com" },
  { hostname: ["outlook.office365.com", "outlook.live.com", "book.ms"], name: "Microsoft Bookings" },
  { hostname: "calendar.google.com", name: "Google Calendar" },
  { hostname: ["acuityscheduling.com", "squarespacescheduling.com"], name: "Acuity Scheduling" },
  { hostname: "hubspot.com", name: "HubSpot Meetings" },
  { hostname: "doodle.com", name: "Doodle" },
  { hostname: "tidycal.com", name: "TidyCal" },
  { hostname: "savvycal.com", name: "SavvyCal" },
];

const FALLBACK_PROVIDER: MeetingProvider = { name: "Meeting Link", icon: Link };

export function detectMeetingProvider(url: string | undefined | null): MeetingProvider {
  if (!url) return FALLBACK_PROVIDER;

  try {
    const hostname = new URL(ensureHttps(url)).hostname.toLowerCase();

    for (const pattern of PROVIDER_PATTERNS) {
      const hostnames = Array.isArray(pattern.hostname) ? pattern.hostname : [pattern.hostname];
      if (hostnames.some(h => hostname === h || hostname.endsWith(`.${h}`))) {
        return { name: pattern.name, icon: Calendar };
      }
    }
  } catch {
    // Invalid URL — fall through to fallback
  }

  return FALLBACK_PROVIDER;
}
